import { tv } from 'tailwind-variants';

export const headingStyles = tv({
  variants: {
    color: {
      primary: 'text-primary',
      light: 'text-white',
      dark: 'text-black',
      'dark-red': 'text-dark-red',
      'light-gray': 'text-grayscale-95',
      'medium-gray': 'text-grayscale-80',
      'dark-gray': 'text-grayscale-96',
      'search-result': 'text-search-result',
    },
  },
});
